var paymentMethodTypes = {
  APPLE_PAY: 'applePay',
  APPLE_PAY_EXPRESS: 'applePayExpress',
  CARD: 'card',
  GOOGLE_PAY: 'googlePay'
};
export { paymentMethodTypes as default };